// extracted by mini-css-extract-plugin
export var header = "styles-module--header--7e239";
export var text = "styles-module--text--5ba90";